import { useContext } from 'react';

import { Spinner } from 'components/Spinner';
import { AddonsContext } from 'contexts/addons';
import { BonusCardSmall } from 'components/BonusCard';

import { ScDepositBonusesSections } from './styled';
import { Payment } from 'payments-lib-types';

interface IDepositBonusesProps {
  paymentMethod?: Payment.Method;
}

export const DepositBonuses = ({ paymentMethod }: IDepositBonusesProps) => {
  const { pendingBonusGroups, pendingBonuses, depositBonuses } = useContext(
    AddonsContext
  );
  if (pendingBonuses || pendingBonusGroups) {
    return <Spinner size={64} center />;
  }

  if (depositBonuses.length === 0) {
    return null;
  }

  return (
    <ScDepositBonusesSections>
      {depositBonuses.map((bonus, index) => (
        <BonusCardSmall
          key={bonus.code ?? index}
          paymentMethod={paymentMethod}
          {...bonus}
        />
      ))}
    </ScDepositBonusesSections>
  );
};
